import axios from 'axios'
import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom'
import { loginUpdate } from '../../redux/actions'

function Login() {
  const [loginData, setLoginData] = useState({
    uid: '',
    password: '',
  })
  const [load, setLoad] = useState(false)
  const dispatch = useDispatch()
  const navigate = useNavigate()

  function inputHandle(e) {
    setLoginData({ ...loginData, [e.target.name]: e.target.value })
  }

  function login(uid, password) {
    axios
      .post(`${process.env.REACT_APP_API_URL}/search_user`, {
        uid,
      })
      .then((res) => {
        if (res.data !== '') {
          if (res.data.password === password) {
            localStorage.setItem(
              '_syt2022_',
              JSON.stringify({
                fname: res.data.fname,
                lname: res.data.lname,
                uid: res.data._id,
                avatar: res.data.avatar,
                bio: res.data.bio,
                following: res.data.following,
                followers: res.data.followers,
              }),
            )
            dispatch(loginUpdate())
            setLoad(false)
            navigate('/')
          } else {
            setLoad(false)
            alert('Wrong username or password. Try agein.')
          }
        } else {
          setLoad(false)
          alert('Wrong username or password. Try agein.')
        }
      })
  }
  return (
    <>
      <div className="col-md-4 col-0"></div>
      <h3 className="mt-5">Login</h3>
      <input
        type={'text'}
        name="uid"
        value={loginData.uid}
        className="mt-5 form-control w-25 p-2"
        placeholder="Username"
        onChange={inputHandle}
      />
      <br />
      <input
        type={'password'}
        name="password"
        value={loginData.password}
        className="form-control w-25 p-2"
        placeholder="Password"
        onChange={inputHandle}
      />
      <br />
      <Link to={'/forgot_password'} className="text-muted">
        Forgot Password?
      </Link>
      <div className="col-12 text-muted">
        Don't have an account?{' '}
        <Link to={'/signup'} className="text-muted">
          Sign up
        </Link>
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 5,
        }}
        className="mt-3"
      >
        <button
          type="button"
          className="btn btn-sm p-2 fs-6 w-25"
          style={{ backgroundColor: '#0696ff', color: '#ffffff' }}
          disabled={load}
          onClick={() => {
            setLoad(true)
            login(loginData.uid, loginData.password)
          }}
        >
          Login
        </button>
        <h6 className="text-muted">or</h6>
        <button
          type="button"
          className="btn btn-sm p-2 fs-6 w-25"
          disabled={load}
          style={{ backgroundColor: '#0696ff', color: '#ffffff' }}
          onClick={() => {
            setLoad(true)
            login('admin', 'admin')
          }}
        >
          Login as a guest
        </button>
      </div>
      <div className="col-md-4 col-0"></div>
    </>
  )
}

export default Login
